import React from "react";
import {
  GSDivider,
  GSInfoGroup,
  defaultGapping,
  defaultLayouts,
  defaultTypography,
  golfstatusColors,
} from "golfstatus_react_components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileCircleCheck,
  faFileCircleExclamation,
} from "@fortawesome/free-solid-svg-icons";

const rowStyle = {
  ...defaultLayouts.hStack,
  ...defaultLayouts.fullWidth,
  ...defaultGapping.largeGap,
  alignItems: "stretch",
};

const iconColumnStyle = {
  ...defaultLayouts.vStack,
  justifyContent: "center",
};

const iconStyle = (complete) => ({
  fontSize: defaultTypography.headline3.fontSize,
  color: complete ? golfstatusColors.cyan700 : golfstatusColors.grey500,
});

const verticalDividerStyle = {
  width: "1px",
  height: "auto",
  alignSelf: "stretch",
  backgroundColor: golfstatusColors.grey200,
};

const infoGroupStyle = { flex: 1 };

const formNameStyle = { ...defaultTypography.body };

const questionNameStyle = {
  ...defaultTypography.bodyRegular,
  color: golfstatusColors.grey800,
  opacity: 0.7,
};

const TournamentOrderFormResponseItem = (props) => {
  const { form, questions, complete } = props;

  const getInfoGroup = () => [
    {
      fit: "stretch",
      sections: [
        {
          sectionItems: [
            {
              type: "primary",
              value: form?.name,
              sectionItemStyle: formNameStyle,
            },
            ...(questions ?? []).map((entry) => ({
              type: "secondary",
              value: entry?.question?.name,
              sectionItemStyle: questionNameStyle,
            })),
          ],
        },
      ],
    },
  ];

  return (
    <tournament-order-form-response-item style={{ display: "block" }}>
      <div style={rowStyle}>
        <div style={iconColumnStyle}>
          <FontAwesomeIcon
            icon={complete ? faFileCircleCheck : faFileCircleExclamation}
            style={iconStyle(complete)}
          />
        </div>
        <GSDivider style={verticalDividerStyle} />
        <GSInfoGroup style={infoGroupStyle} dataGroups={getInfoGroup()} />
      </div>
    </tournament-order-form-response-item>
  );
};

export default TournamentOrderFormResponseItem;
